module.exports = __webpack_public_path__ + "static/media/pin_buckle_steel.dcf62b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_buckle_steel.png
// module id = 107
// module chunks = 0